import {NumberWrap, TestingInput} from './styles.js';
import React from 'react';
import Grid from '../../../molecules/Grid';
import TestingAnswerContent from '../TestingAnswerContent/TestingAnswerContent';
import Icon from '../../../atoms/UI/Icon/Icon';
import IconButton from '../../../atoms/UI/buttons/IconButton';
import ErrorMessage from '../../../atoms/UI/forms/ErrorMessage/ErrorMessage';
import { useFormContext } from 'react-hook-form';

type TextFieldType = {
    label?: string;
    name: string;
    value?: string | undefined;
    onChange?: any;
    placeholder?: string;
    required?: boolean | undefined;
    type?: string | undefined;
    disabled?: boolean;
    imgSrc?: string;
    isCorrect?: boolean | undefined;
    isComment?: boolean;
    commentText?: string
    step?: string;
    min?: string;
    max?:  string;
    error?: string | null | undefined;
    minLength?: string;
    maxLength?: string;
};

const TestingFormTextField: React.FC<TextFieldType> = (
    {
        label, name, type, value, onChange, placeholder,
        disabled, imgSrc, isCorrect, isComment,
        commentText, step, error, required,
        min, max
    }) => {


    let numberClass = type === 'number' ? 'number' : '';

    const numericValue = parseFloat(value || "0");
    const numericStep = step ? parseFloat(step) : 1;
    const minValue = parseFloat(min || "-Infinity");
    const maxValue = parseFloat(max || "Infinity")

    const handleAdjustValue = (increment: boolean) => {
        const newValue = increment ? numericValue + numericStep : numericValue - numericStep;
        const event = {
            target: { value: newValue.toString(), name }
        };
        onChange(event);
    };

    return (
        <Grid col='1' gap='2'>
            <TestingAnswerContent
                imgSrc={imgSrc}
                label={label}
                isComment={isComment}
                commentText={commentText}
                isCorrect={isCorrect}
                isSelected={value}
                isDisabled={disabled}
                required={required}
            />

            <NumberWrap className={numberClass}>
                {(type === 'number') &&
                    <IconButton
                        className={(numericValue <= minValue) ? 'disabled' : ''}
                        disabled={numericValue <= minValue}
                        type='button'
                        onClick={() => handleAdjustValue(false)}>
                    <Icon name='Minus' xSmall/>
                </IconButton>}

                <TestingInput
                    name={name}
                    className={isCorrect ? 'isCorrect' : isCorrect === false ? 'isError' : '' }
                    type={type}
                    value={value}
                    step={step}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                />
                {(type === 'number') &&
                    <IconButton
                        className={(numericValue >= maxValue) ? 'disabled' : ''}
                        disabled={numericValue >= maxValue}
                        type='button'
                        onClick={() => handleAdjustValue(true)}>
                    <Icon name='Plus' xSmall/>
                </IconButton>}
            </NumberWrap>
            {error && <ErrorMessage>{error}</ErrorMessage>}

        </Grid>
    );
};

export default TestingFormTextField